import React from "react";
import "./privacyPolicy.scss";
import { Stack } from "@mui/material";
import { PRIVACY_POLICY_DATA } from "../../constant";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <div className="title">Privacy Policy</div>
      {/* <div className="main-container">
        <div className="privacy-policy-list">
          {PRIVACY_POLICY_DATA.map((item) => (
            <div className="single-privacy-policy" key={item.id}>
              <div className="pp-title">{item.title}</div>
              <Stack className="pp-content" spacing={2}>
                {item.content}
              </Stack>
            </div>
          ))}
        </div>
      </div> */}
      <div className="main-container">
        <p>
          <strong>Effective Date:</strong> April 20, 2025
        </p>

        <p>
          At KRISTIVE, we value your privacy and are committed to
          protecting your personal information. This policy outlines how we
          collect, use, and safeguard your data:
        </p>
        <ol style={{ paddingLeft: "30px" }}>
          <li>
            <strong>Information Collection:</strong> We collect personal information such as
            name, contact details, and payment information when you place an
            order or subscribe to our newsletter.
          </li>
          <li>
            <strong>Use of Information:</strong> Your information is used to process orders,
            provide customer support, and send promotional communications (if
            opted-in).
          </li>
          <li>
            <strong>Data Protection:</strong> We implement appropriate security measures to
            protect your data from unauthorized access or disclosure.
          </li>
          <li>
            <strong>Third-Party Sharing:</strong> We do not sell or rent your personal
            information to third parties. Data may be shared with service
            providers solely for order fulfillment and delivery purposes.
          </li>
          <li>
            <strong>Cookies:</strong> Our website uses cookies to enhance user experience. You
            can choose to disable cookies through your browser settings.
          </li>
          <li>
            <strong>Your Rights:</strong> You have the right to access, modify, or delete your
            personal information. To exercise these rights, please contact us at
            support@kristive.com.
          </li>
        </ol>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
